<div class="input-box-card">
  <label class="input-box-label">{{ label || title }}</label>

  <div class="input-box-row">
    <input
      type="text"
      class="input-box-control"
      [placeholder]="placeholder || 'Enter a value'"
      [(ngModel)]="inputValue"
      (change)="valueChange.emit(inputValue)"
    />
    <button
      *ngIf="canCompute"
      type="button"
      class="input-compute-trigger"
      title="On-the-Fly Computation"
      aria-label="On-the-Fly Computation"
      (click)="toggleCompute($event)"
    >
      <span class="material-icons">bolt</span>
    </button>
  </div>
  <span class="input-box-formatted-value" *ngIf="formattedValue">≈ {{ formattedValue }}</span>

  <div class="input-compute-popover" *ngIf="computeOpen" (click)="$event.stopPropagation()">
    <div class="compute-header">
      <strong>On-the-Fly Computation</strong>
      <button type="button" class="compute-close" aria-label="Close" (click)="closeCompute()">x</button>
    </div>

    <div class="compute-body">
      <div class="compute-chips" *ngIf="allColumns.length">
        <button
          *ngFor="let column of allColumns"
          type="button"
          class="compute-chip"
          [class.numeric]="column.type === 'number'"
          (click)="appendColumn(column)"
        >
          {{ column.name }}
        </button>
      </div>

      <label class="compute-label">Entity Name</label>
      <input class="compute-input" type="text" [value]="entityName" readonly placeholder="No entity found" />

      <label class="compute-label">Expression</label>
      <div class="compute-expression-row">
        <input
          class="compute-input"
          type="text"
          [(ngModel)]="currentExpression"
          placeholder="e.g. price + margin"
        />
        <input
          class="compute-input alias"
          type="text"
          [(ngModel)]="currentAlias"
          placeholder="Alias"
        />
        <button type="button" class="compute-add" (click)="addComputation()">+</button>
      </div>
      <small class="compute-error" *ngIf="expressionError">{{ expressionError }}</small>

      <div class="compute-list" *ngIf="computations.length">
        <div class="compute-item" *ngFor="let entry of computations; trackBy: trackByComputation">
          <span>{{ entry.raw }}</span>
          <button type="button" (click)="removeComputation(entry.id)">x</button>
        </div>
      </div>

      <div class="compute-section" *ngIf="numericColumns.length">
        <label class="compute-label">Range Filters</label>
        <div class="compute-chips">
          <button
            *ngFor="let column of numericColumns"
            type="button"
            class="compute-chip"
            [class.active]="hasFilter(column.name)"
            (click)="toggleFilter(column)"
          >
            {{ column.name }}
          </button>
        </div>
      </div>

      <div class="range-list" *ngIf="numericFilters.length">
        <div class="range-item" *ngFor="let filter of numericFilters; trackBy: trackByFilter">
          <div class="range-title">
            <span>{{ filter.column }}</span>
            <button type="button" (click)="removeFilter(filter.column)">x</button>
          </div>
          <div class="range-inputs">
            <input
              type="number"
              [min]="filter.absoluteMin"
              [max]="filter.currentMax"
              [value]="filter.currentMin"
              (change)="updateFilterValue(filter, 'currentMin', $event)"
            />
            <input
              type="number"
              [min]="filter.currentMin"
              [max]="filter.absoluteMax"
              [value]="filter.currentMax"
              (change)="updateFilterValue(filter, 'currentMax', $event)"
            />
          </div>
        </div>
      </div>

      <pre class="compute-preview" *ngIf="resultPreview">{{ resultPreview | json }}</pre>
      <small class="compute-error" *ngIf="errorMessage">{{ errorMessage }}</small>
      <small class="compute-success" *ngIf="successMessage">{{ successMessage }}</small>
    </div>

    <div class="compute-footer">
      <button type="button" class="compute-secondary" (click)="clearAll()">Clear All</button>
      <button type="button" class="compute-primary" [disabled]="loading" (click)="apply()">
        {{ loading ? 'Applying...' : 'Apply' }}
      </button>
    </div>
  </div>
</div>
